(function(){
    'use strict'; 
    angular.module('Directives').directive('bbaPickupScheduleDetails', bbaPickupScheduleDetails);

    bbaPickupScheduleDetails.$inject = []; 

    function bbaPickupScheduleDetails() {
        return {
            restrict: 'E', 
            templateUrl: '/templates/directives/form-components/bba-pickup-schedule-details.html', 
            replace: true,
            scope: {
                schedule: '=?',
                scheduleForm: '=?',
                name: '=?'
            },
            link: bbaPickupScheduleDetailsLink
        }

        function bbaPickupScheduleDetailsLink($scope) {
            $scope.hoursTimeOptions = [];
            $scope.minutestTimeOptions = [];

            $scope.weekDays = [
                { short: 'Mon', long: 'MONDAY', status: false },
                { short: 'Tue', long: 'TUESDAY', status: false },
                { short: 'Wed', long: 'WEDNESDAY', status: false },
                { short: 'Thu', long: 'THURSDAY', status: false },
                { short: 'Fri', long: 'FRIDAY', status: false }
            ];
            $scope.timeAmPm = [
                { name: 'AM', value: 'am' },
                { name: 'PM', value: 'pm' }
            ];
            $scope.timeOptions = [];

            init();

            function init() {
                initHoursTimeOption(); 
                initMinutesTimeOptions();
            }

            function initHoursTimeOption() {
                if ($scope.hoursTimeOptions.length == 0) {
                    for (let i = 1; i < 25; i++) {
                        if (i < 10) {
                            $scope.hoursTimeOptions.push(`0${i}`);
                        } else {
                            $scope.hoursTimeOptions.push(i)
                        }
                    }
                }
            }
            
            function initMinutesTimeOptions() {
                if ($scope.minutestTimeOptions.length == 0) {
                    for (let i = 1; i < 61; i++) {
                        if (i < 10) {
                            $scope.minutestTimeOptions.push(`0${i}`);
                        } else {
                            $scope.minutestTimeOptions.push(i)
                        }
                    }
                }
            }
        }
    }
})()



// WEBPACK FOOTER //
// ./js/directives/form-components/bbaPickupScheduleDetails.js